import React, {  useState } from "react";
import { Form, Row, Col, Button, Container, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

function Literature_Master() {

    const [comment, setComment] = useState("");
    const [literature, setLiterature] = useState("");

    const { user: loggedUser } = useAuth();
    const navigate = useNavigate();

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);







    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);



        try {
            const payload = {
                literature,
                remark: comment,
            };

            const response = await axios.post(
                `${API_URL}/add_literature_master`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );


            setSuccessMsg(response.data.message || "Add successfully");
            setErrorMsg("");

            setTimeout(() => {
                navigate("/Literature_Master_List");
            }, 1000);


            setLiterature("");
            setComment("");


        } catch (error) {
            console.error(error);

            setErrorMsg("Update failed");

            setTimeout(() => setErrorMsg(""), 1000);
        } finally {
            setIsSubmitting(false);

        }
    };

    return (
        <Container className="mt-4">
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}

            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <h3>Literature Master</h3>
                <Link className="btn btn-primary btn-sm mt-2 mt-md-0" to="/Literature_Master_List">
                    List
                </Link>
            </div>

            <Form autoComplete="off" onSubmit={handleSubmit}>


                <Row className="mt-4">
                    <Col xs={12}>
                        <Form.Label className="fw-semibold">Literature Name</Form.Label>


                        <Form.Control


                            value={literature}
                            onChange={(e) => setLiterature(e.target.value)}
                        />

                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12}>
                        <FloatingLabel label="Enter Comments">
                            <Form.Control
                                as="textarea"
                                style={{ height: "80px" }}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col className="text-center">
                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Submit"}                        </Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

export default Literature_Master;
